import { Router, route } from "preact-router";
import "./style/index.css";
import WelcomeScreen from "./routes/welcome";
import SignInScreen from "./routes/sign-in";
import ForgotPassword from "./components/forgotPassword";
import HomeScreen from "./routes/home";
import RequestsScreen from "./routes/requests";
import PlayedSongsScreen from "./routes/played-songs";
import SongSlotsScreen from "./routes/song-slots";
import Profile from "./components/profile";
import PlaylistScreen from "./routes/playlist";
import AnalyticsScreen from "./routes/analytics";
import { Provider } from "react-redux";
import store from "./store";
import VerificationError from "./components/verificationError";
import {
  clearLocalStorage,
  clearSessionStorage,
  getCookie,
  getLocalStorage,
} from "./utils";
import { useEffect, useState } from "preact/hooks";
import { Fragment } from "preact";
import BasicModal from "./components/common/basicModal";
import { modalConfig } from "./actionTypes";
import { Button } from "@mui/base";
import ReviewPageScreen from "./routes/review-page";
import ChangePasswordScreen from "./routes/change-password";
export default function App() {
  const [showReloadModal, setShowReloadModal] = useState(false);

  const handleCloseSlotCloseModal = () =>
    store.dispatch({ type: modalConfig.CLOSE_REFRESH_MODAL });

  useEffect(() => {
    const interval = setInterval(() => {
      if (
        ["/", "sign-in", "forgot-password", "verification-error"].includes(
          window.location.pathname.length > 1
            ? window.location.pathname.replaceAll("/", "")
            : window.location.pathname
        )
      ) {
        if (
          getCookie("user_key") &&
          getLocalStorage("host") &&
          getLocalStorage("host_name")
        ) {
          route("/home", true);
        }
        return;
      }
      if (!getCookie("user_key") || !getLocalStorage("host")) {
        clearSessionStorage();
        clearLocalStorage();
        route("/verification-error", true);
      }
    }, 2000);

    const timeout = setTimeout(() => {
      if (
        ["/", "sign-in", "forgot-password", "verification-error"].includes(
          window.location.pathname.length > 1
            ? window.location.pathname.replaceAll("/", "")
            : window.location.pathname
        )
      ) {
        if (
          getCookie("user_key") &&
          getLocalStorage("host") &&
          getLocalStorage("host_name")
        ) {
          route("/home", true);
          return;
        } else {
          return;
        }
      } else {
        if (
          !getCookie("user_key") ||
          !getLocalStorage("host") ||
          !getLocalStorage("host_name")
        ) {
          route("/", true);
          return;
        }
      }
    }, 500);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
      if (timeout) {
        clearTimeout(timeout);
      }
    };
  }, [
    getCookie("user_key"),
    getLocalStorage("host"),
    getLocalStorage("host_name"),
  ]);

  useEffect(() => {
    store.subscribe(() => {
      setShowReloadModal(store.getState()?.config?.showRefreshModal);
    });
  }, []);

  return (
    <Provider store={store}>
      <>
        <Router>
          <WelcomeScreen path="/" />
          <SignInScreen path="/sign-in/" />
          <ForgotPassword path="/forgot-password/" />
          <HomeScreen path="/home/" />
          <RequestsScreen path="/requests/" />
          <PlayedSongsScreen path="/played-songs/" />
          <SongSlotsScreen path="/slots/" />
          <PlaylistScreen path="/songs-list/" />
          <Profile path="/profile/" />
          <AnalyticsScreen path="/analytics/" />
          <VerificationError path="/verification-error/" />
          <ReviewPageScreen path="/review-page/" />
          <ChangePasswordScreen path="/change-password/" />
        </Router>
        <Fragment>
          <BasicModal
            open={showReloadModal}
            handleClose={handleCloseSlotCloseModal}
          >
            <div className="modalHeaderText">Refresh</div>
            <div className="modalSubText">
              Weak connection. Please check your network and reload.
            </div>

            <Button
              onClick={() => {
                store.dispatch({
                  type: modalConfig.CLOSE_REFRESH_MODAL,
                });
                window.location.reload();
              }}
              className="modalButton"
            >
              Reload
            </Button>
          </BasicModal>
        </Fragment>
      </>
    </Provider>
  );
}
